import React from 'react';

import { ButtonBase } from '@mui/material';

import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import { useStyles } from './InteractiveFilePreview.styles';
import theme from '../../../../styles/theme';

interface InteractiveFilePreviewProps {
  fileSrc: string;
  alt: string;
  type?: 'image' | 'video';
  onClickPreview?: () => void;
}

export default function InteractiveFilePreview(
  props: InteractiveFilePreviewProps,
) {
  const {
    fileSrc,
    alt = '',
    type = 'image',
    onClickPreview = () => {},
  } = props;
  const { classes } = useStyles(theme);

  return (
    <>
      <ButtonBase
        className={classes.mediaPreview}
        onClick={onClickPreview}
        aria-label="Open Image">
        {type === 'image' ? (
          <img src={fileSrc} alt={alt} />
        ) : (
          <PlayCircleOutlineIcon />
        )}
      </ButtonBase>
      {/*<Dialog*/}
      {/*  PaperProps={{ className: classes.mediaDialog }}*/}
      {/*  open={openImage}*/}
      {/*  onClose={() => setOpenImage(false)}>*/}
      {/*  <IconButton*/}
      {/*    className={classes.closeButton}*/}
      {/*    onClick={() => setOpenImage(false)}*/}
      {/*    aria-label="close">*/}
      {/*    <Close/>*/}
      {/*  </IconButton>*/}
      {/*  {type === 'image' ? (*/}
      {/*    <a*/}
      {/*      className={classes.mediaFull}*/}
      {/*      href={fileUrl || localPath}*/}
      {/*      target="_blank"*/}
      {/*      rel="noreferrer">*/}
      {/*      <img style={imgStyles} src={fileUrl || localPath} alt={alt}/>*/}
      {/*    </a>*/}
      {/*  ) : (*/}
      {/*    null*/}
      {/*    // <ReactPlayer controls url={fileUrl} width={600} />*/}
      {/*  )}*/}
      {/*</Dialog>*/}
    </>
  );
}
